const Backbone = require('backbone');
const FacetViews = require('app/views/store/pages/categories/facet_views');
const SocialBarView = require('app/views/store/common/social/social_bar');
const ContentDropView = Backbone.View.extend({
	el: '#page-content',

	initialize: function() {
		this._initChildViews();

		this.isMobileNarrowUiShown = false;
	},

	events: {
		'click .js-narrow-results': '_showNarrowResultsUi'
	},

	_resetPaginationData: function() {
		this.childViews.pagination.model.set({
			activePage: 1
		});
	},

	_handleQueryChange: function() {
		window.location.search = this._getQueryParams().join('&');
	},

	_showNarrowResultsUi: function() {
		if (!this.isMobileNarrowUiShown) {
			Backbone.trigger('omniture:clicktracking', 'mobile-show-facet-ui');
			this.isMobileNarrowUiShown = true;
		}
	},

	_initChildViews: function() {
		this.childViews = {
			facetViews: new FacetViews({
				facetListView: {
					enabled: true,
					el: '.js-facet-options',
					startCollapsed: !window.BCOM.device.isDesktop
				},
				facetMenuView: {
					enabled: !window.BCOM.device.isDesktop
				},
				getQueryParams: this._getQueryParams.bind(this),
				onFacetsChange: this._onFacetViewsChange.bind(this)
			}),
			pagination: $('.js-pagination-component').data('componentView'),
			social: new SocialBarView()
		};
	},

	_onFacetViewsChange: function() {
		this._resetPaginationData();
		this._handleQueryChange();
	},

	_getQueryParams() {
		const queryParams = [],
			page = this.childViews.pagination.getActivePage(),
			intcmp = window.BCOM.util.getQueryStringParameter('intcmp', window.location.href),
			facetQueries = this.childViews.facetViews.getFacetQueries().map((fq) => {
				const facetId = window.encodeURIComponent(fq.split('=')[0]);
				return `${facetId}=${fq.split('=')[1]}`;
			});

		if (intcmp) {
			queryParams.push(`intcmp=${intcmp}`);
		}
		if (page) {
			queryParams.push(`p=${page}`);
		}

		return queryParams.concat(facetQueries);
	}
});
module.exports = ContentDropView;
